import { atom } from "recoil";

// 選択した病院情報
export const selectedCourceClinicState = atom({
  key: "selectedCourceClinicState",
  default: {
    id: '',
    clinic_id: null,
    name: null,
    prefecture_code: null,
    address: null,
    tel: null,
  },
});